import { gql } from "@apollo/client";

export const FEEDBACKS = gql`
  query fetchUserFeedbacks($pagination: PaginationInputType) {
    fetchUserFeedbacks(pagination: $pagination) {
      userFeedbacks {
        id
        message
        category
        email
        Media {
          url
        }
        status
        User {
          username
          firstName
          lastName
        }
      }
      total
    }
  }
`;